import { render, staticRenderFns } from "./newConfirm.vue?vue&type=template&id=71bae9d5&scoped=true&"
import script from "./newConfirm.vue?vue&type=script&lang=js&"
export * from "./newConfirm.vue?vue&type=script&lang=js&"
import style0 from "./newConfirm.vue?vue&type=style&index=0&id=71bae9d5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bae9d5",
  null
  
)

export default component.exports